exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LayerList {\n    padding: 16px 0 0 16px;\n    overflow-y: auto;\n    max-width: 680px;\n    max-height: calc(100vh - 150px);\n}\n\n.Layer {\n    float: left;\n    width: 120px;\n    margin-right: 16px;\n    cursor: pointer;\n    box-sizing: border-box;\n    height: 160px;\n}\n\n.Layer-image {\n    box-sizing: border-box;\n    border: 1px solid #555;\n    width: 120px;\n    height: 120px;\n}\n\n.Layer-no-image {\n    box-sizing: border-box;\n    border: 1px solid #555;\n    width: 120px;\n    height: 120px;\n    line-height: 120px;\n    background: #eee;\n    color: #ccc;\n    font-size: 12px;\n    text-align: center;\n    margin-bottom: 4px;\n}\n\n.Layer-name {\n    font-size: 14px;\n    color: #333;\n    padding-bottom: 20px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/layers/layers/Layer.css
// module id = 955
// module chunks = 0